import {createActionWithPayload} from "../utils.actions";
import {PublicationSearchFilters} from "../../../types/common-search";
import {EntityProposal} from "../../../types/quick-search";

export const [loadAutoCompletePublication, isLoadAutoCompletePublicationAction] = createActionWithPayload<PublicationSearchFilters>('LOAD_AUTOCOMPLETE_PUBLICATIONS');
export const [loadAutoCompletePublicationSuccess, isLoadAutoCompletePublicationSuccesAction] = createActionWithPayload<EntityProposal[]>('LOAD_AUTOCOMPLETE_PUBLICATIONS_SUCCESS');
export const [loadAutoCompletePublicationError, isLoadAutoCompletePublicationErrorAction] = createActionWithPayload<string>('LOAD_AUTOCOMPLETE_PUBLICATIONS_ERROR');
